import TransactionDetails from './transactionDetails'

export default TransactionDetails